

















































import Vue from "vue";

import { states } from "../../assets/helptexts/swtich-tooltips";
import { SwitchInfo } from "builder";

export default Vue.extend({
  name: "StateSwitch",
  components: {},
  data() {
    return {
      state: states[0] as SwitchInfo
    };
  },
  mounted() {
    this.$emit("state", this.state);
  },

  computed: {
    switchInfo: function(): SwitchInfo[] {
      return states;
    }
  },
  methods: {
    clicked: function(state: number): void {
      this.state = this.switchInfo[state];
    }
  },
  watch: {
    state: function(newval: string): void {
      this.$emit("state", this.state);
    }
  }
});
